









import { Component } from 'vue-property-decorator';
import FacetSearchBase from './FacetSearchBase.vue';
import FacetSearchFilterSelection from './FacetSearchFilterSelection.vue';

@Component({
  components: {
    FacetSearchFilterSelection,
  },
})
export default class FacetSearchDesktop extends FacetSearchBase {}
